
import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { InvoiceServices } from '../services/invoiceServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { WinbizServices } from '../services/winbizServices';

export default class InvoiceStore {
 
    rootStore;
    /*activities = [];
    activity = {};*/
    /*months = [];
    month = {};*/

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            /*activities: observable,
            activity: observable,
            getAll: action,
            getById: action,
            remove: action,
            save: action,
            reset: action,
            duplicate: action,
            getUserActivities: action,*/
            sendViaEmail: action,
            cancel: action,
            createCreditNote: action,
            changeDate:action
            
        });
    }

    

    sendViaEmail = async (payload, onSuccess) => {

        try {
            
            const data = await InvoiceServices.sendViaEmail(payload);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                //this.reset();
                toast.success(`${i18n.t("invoiceSent")}`);
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }

    };

    cancel = async (id,isCreditNote,onSuccess) => {
        try {
            const data = await InvoiceServices.cancel(id, isCreditNote);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                //this.reset();
                toast.success(`${i18n.t(isCreditNote ?"creditNoteCancelled":"invoiceCancelled")}`);
            });
        } catch (error) {
            
        }
    }
    createCreditNote = async (id, onSuccess) => {
        try {
            const data = await InvoiceServices.createCreditNote(id);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                //this.reset();
                toast.success(`${i18n.t("creditNoteCreated")}`);
            });
        } catch (error) {

        }
    }

    changeDate = async (id,year,month,day, onSuccess) => {
        try {
            const data = await InvoiceServices.changeDate({id:id,year:year,month:month,day:day/* date: date */});
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                //this.reset();
                toast.success(`${i18n.t("invoiceDateChanged")}`);
            });
        } catch (error) {

        }
    }
}